export default __webpack_public_path__ + "static/media/Love07.f07f9f61.png";